import { RadixDappToolkit, Logger, DataRequestBuilder } from "@radixdlt/radix-dapp-toolkit";
import { DAPP_DEFINITION_ACCOUNT_ADDRESS, RADIX_NETWORK_ID } from "~/lib/util";

const isBrowser = typeof document !== 'undefined';

let rdtInstance;

if (isBrowser) {
  rdtInstance = RadixDappToolkit({
    dAppDefinitionAddress: DAPP_DEFINITION_ACCOUNT_ADDRESS,
    networkId: RADIX_NETWORK_ID,
    applicationName: 'DefiPlaza',
    applicationVersion: '1.0.0',

    logger: Logger(2),
  });

  rdtInstance.walletApi.setRequestData(DataRequestBuilder.accounts().atLeast(1));
}

export const rdt = rdtInstance;